import { GradientMesh } from '@/components/GradientMesh';
import NewsletterForm from '@/components/NewsletterForm';
import SocialIcon from '@/components/social-icons';
import { GRADIENT_MESH } from '@/data/colorGradient';
import siteMetadata from '@/data/siteMetadata';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import Link from './Link';

const pagesWithoutGradientFooter: string[] = [];

export default function Footer() {
  const { pathname } = useRouter();

  const includeGradient = useMemo(() => !pagesWithoutGradientFooter.includes(pathname), [pathname]);

  return (
    <footer>
      <div className="relative flex flex-col items-center">
        <div className="relative h-80 w-screen overflow-hidden bg-white md:h-64">
          {includeGradient && <GradientMesh colorPalette={GRADIENT_MESH} opacity={0.5} />}
        </div>
        <div className="absolute top-0 mt-8 flex w-full flex-col items-center pt-6">
          {siteMetadata.newsletter.provider !== '' && (
            <div className="flex items-center justify-center pt-4">
              <NewsletterForm title={''} />
            </div>
          )}
          <div className="my-4 mb-3 flex space-x-4">
            <SocialIcon kind="mail" href={`mailto:${siteMetadata.email}`} />
            {/* <SocialIcon kind="github" href={siteMetadata.github} /> */}
            {/* <SocialIcon kind="facebook" href={siteMetadata.facebook} /> */}
            {/* <SocialIcon kind="youtube" href={siteMetadata.youtube} /> */}
            <SocialIcon kind="linkedin" href={siteMetadata.linkedin} />
            <SocialIcon kind="twitter" href={siteMetadata.twitter} />
            <SocialIcon kind="slack" href={siteMetadata.slack} />
          </div>
          <div className="mb-2 flex space-x-2 text-sm text-black">
            <div>{siteMetadata.author}</div>
            <div>{` • `}</div>
            <div>{`© ${new Date().getFullYear()}`}</div>
            <div>{` • `}</div>
            <Link href="/">{siteMetadata.title}</Link>
          </div>
          <div className="text-sm text-gray-800">
            <Link href="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
